// CTA.jsx
import React from 'react';

export const CTA = ({ onStart }) => {
  return (
    <section className="py-32 bg-white">
      <div className="max-w-4xl mx-auto text-center px-6">
        <h2 className="text-5xl font-bold text-black mb-6 just-me">
          Thousands of users trust us with their businesses. You can too.
        </h2>

        <button onClick={onStart} className="px-10 py-4 bg-black text-white rounded-xl">
          Create Your First Website
        </button>
      </div>
    </section>
  );
};
